export default __webpack_public_path__ + "static/media/gear-bg.bdb352b7.webp";